import React from "react";
import "../../../.TrainerOffice/components/row-office/row-office.scss";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import { Link } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import Toolbar from "@material-ui/core/Toolbar";
import { makeStyles } from "@material-ui/core/styles";
/*import Badge from "@material-ui/core/Badge";*/
import MessageIcon from "@material-ui/icons/Message";
import NotificationsIcon from "@material-ui/icons/Notifications";
import noAvatar from "../../../components/img/no_avatar.png";
import { ReactComponent as Main } from "../../../icons-office/main.svg";
import { ReactComponent as Finance } from "../../../icons-office/finance.svg";
import { ReactComponent as Settings } from "../../../icons-office/settings.svg";
import { ReactComponent as Chat } from "../../../icons-office/chat.svg";
import logo from "../../../components/img/logo.png";
import phone from "../../../components/img/phone.png";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import { withStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import Menu from "@material-ui/core/Menu";
import { compose } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router";
import { signOut } from "../../../store/actions/auth";

const drawerWidth = 240;

export const StyledListItem = withStyles({
  root: {
    backgroundColor: "inherit",
    "&.Mui-selected": {
      backgroundColor: "inherit",
    },
    "&.Mui-selected:hover": {
      backgroundColor: "inherit",
    },
    "&.MuiListItem-button:hover": {
      backgroundColor: "inherit",
    },
    "&.MuiListItem-button": {
      transition: "none",
    },
    "&.Mui-active": {
      backgroundColor: "inherit",
    },
  },
})(ListItem);

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: "Apple SD Gothic Neo",
    backgroundColor: "#FFFFFF",
    display: "flex",
    height: "100vh",
    [theme.breakpoints.down("xs")]: {
      backgroundColor: "#FAFAFC",
    },
  },
  drawer: {
    fontFamily: "Apple SD Gothic Neo",
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "inherit",
    boxShadow: "none",
  },
  menuButton: {
    marginLeft: "auto",
    color: "#454545",
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    fontFamily: "Apple SD Gothic Neo",
    backgroundColor: "inherit",
    [theme.breakpoints.down("xs")]: {
      backgroundColor: "#FFFFFF",
      width: "90%",
    },
    border: "none",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    [theme.breakpoints.down("xs")]: {
      padding: 0,
    },
  },
  closeMenuButton: {
    marginRight: "auto",
    marginLeft: 0,
  },
  listItemText: {
    fontWeight: 700,
  },
  listItemTextMobile: {
    fontWeight: 700,
    color: "#454545",
    fontSize: "24px",
    fontFamily: "Apple SD Gothic Neo",
  },
}));

const RowClientOffice = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const isMenuOpen = Boolean(anchorEl);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
    handleDrawerToggle();
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const singOut = () => {
    dispatch(signOut());
    props.history.push("/client/login");
  };

  const dummyCategoriesMobile = [
    {
      label: "Главная",
      link: "/client/",
      index: 0,
    },
    {
      label: "Финансы",
      link: "/client/finance",
      index: 2,
    },
    {
      label: "Настройки",
      link: "/client/settings",
      index: 3,
    },
  ];

  const dummyCategories = [
    {
      label: "Главная",
      icon: <Main fill={"#4594CC"} stroke={"#4594CC"} />,
      link: "/client/",
      index: 0,
      onIcon: <Main fill={"#FFFFFF"} stroke={"#858585"} />,
    },
    /*{
      label: "Сообщения",
      icon: <Chat fill={"#4594CC"} stroke={"#FFFFFF"} />,
      link: "/client/messages",
      index: 1,
      onIcon: <Chat fill={"#FFFFFF"} stroke={"#858585"} />,
    },*/
    {
      label: "Финансы",
      icon: <Finance fill={"#4594CC"} stroke={"#4594CC"} />,
      link: "/client/finance",
      index: 2,
      onIcon: <Finance fill={"#FFFFFF"} stroke={"#858585"} />,
    },
    {
      label: "Настройки",
      icon: <Settings fill={"#4594CC"} stroke={"#4594CC"} />,
      link: "/client/settings",
      index: 3,
      onIcon: <Settings fill={"#FFFFFF"} stroke={"#858585"} />,
    },
    /*{
      label: "Страхование",
      icon: <Settings fill={"#4594CC"} stroke={"#4594CC"} />,
      link: "/client/strhovanie",
      index: 4,
      onIcon: <Settings fill={"#FFFFFF"} stroke={"#858585"} />,
    },*/
  ];

  const drawer = (
    <div className="navBar">
      <List>
        {dummyCategories.map(({ label, icon, link, index, onIcon }) => (
          <StyledListItem
            button
            key={index}
            component={Link}
            to={link}
            dense
            selected={selectedIndex === index}
            onClick={(event) => handleListItemClick(event, index)}
          >
            {selectedIndex === index ? (
              <>
                <ListItemIcon>{icon}</ListItemIcon>

                <ListItemText
                  primary={label}
                  classes={{ primary: classes.listItemText }}
                  style={{
                    color: "#4594CC",
                  }}
                />
              </>
            ) : (
              <>
                <ListItemIcon>{onIcon}</ListItemIcon>
                <ListItemText
                  primary={label}
                  style={{
                    color: "#858585",
                    fontSize: "1rem",
                  }}
                />
              </>
            )}
          </StyledListItem>
        ))}
      </List>
      <img src={logo} alt="Логотип" className="logo" />
    </div>
  );
  const drawerMobile = (
    <div className={"drawerMobile"}>
      <List>
        {dummyCategoriesMobile.map(({ label, link, index }) => (
          <StyledListItem
            button
            key={index}
            component={Link}
            to={link}
            dense
            selected={selectedIndex === index}
            onClick={(event) => handleListItemClick(event, index)}
          >
            {selectedIndex === index ? (
              <ListItemText
                primary={label}
                classes={{ primary: classes.listItemTextMobile }}
              />
            ) : (
              <ListItemText
                primary={label}
                classes={{ primary: classes.listItemTextMobile }}
              />
            )}
          </StyledListItem>
        ))}
      </List>
      <div className="navInfo">
        <div className="navInfoContent">
          <span>Администратор</span>
          <span className="navInfoSchedule">Пн-Пт 10:00-20:00</span>
          <a href="tel:+7 (903) 096-90-00">+7 (903) 096-90-00</a>
        </div>
        <a href="tel:+7 (903) 096-90-00">
          <img alt="call" src={phone} />
        </a>
      </div>
      <div className="navFooter">
        <img src={logo} alt="logo" />
        <Button variant="outlined" onClick={singOut}>
          Выйти
        </Button>
      </div>
    </div>
  );
  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      getContentAnchorEl={null}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem disabled />
      <Box my={1}>
        <Divider />
      </Box>
      <MenuItem disabled>{user?.email}</MenuItem>
      <MenuItem onClick={singOut}>Выйти</MenuItem>
    </Menu>
  );

  if (!user) {
    return null;
  }

  return (
    <div className={classes.root} id="root">
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <Link to={"/client"}>
            {user.avatar !== null ? (
              <img
                alt="avatar"
                src={user.avatar?.full_url}
                className="avatarResponsive"
              />
            ) : (
              <img alt="avatar" src={noAvatar} className="avatarResponsive" />
            )}
          </Link>
          <div className="toolbar">
            {/*<IconButton*/}
            {/*  aria-label="mails"*/}
            {/*  color="inherit"*/}
            {/*  className="badgeMessage"*/}
            {/*>*/}
            {/*  /!*<Badge badgeContent={} color="secondary">*!/*/}
            {/*  <Link to={"/client/messages"}>*/}
            {/*    <MessageIcon style={{ color: "#4594CC" }} />*/}
            {/*  </Link>*/}
            {/*  /!*</Badge>*!/*/}
            {/*</IconButton>*/}
            <IconButton
              aria-label="notifications"
              color="inherit"
              className={classes.badge}
            >
              {/*<Badge badgeContent={} color="secondary">*/}
              <NotificationsIcon style={{ color: "#4594CC" }} />
              {/*</Badge>*/}
            </IconButton>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              className={classes.menuButton}
            >
              <MenuIcon />
            </IconButton>
          </div>
          <div className="avatarContainer">
            <span>{user.first_name}</span>
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
              className="avatar"
            >
              {user.avatar !== null ? (
                <img alt="avatar" src={user.avatar?.full_url} />
              ) : (
                <img alt="avatar" src={noAvatar} />
              )}
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMenu}

      <nav className={classes.drawer}>
        <Hidden smUp implementation="css">
          <Drawer
            className="drawer"
            variant="temporary"
            anchor={"right"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true,
            }}
          >
            <IconButton
              onClick={handleDrawerToggle}
              className={classes.closeMenuButton}
            >
              <CloseIcon />
            </IconButton>
            {drawerMobile}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            className={classes.drawer}
            variant="permanent"
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            <div className={classes.toolbar} />
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <div className={classes.content}>
        <div className={classes.toolbar} />
        {props.children}
      </div>
    </div>
  );
};
RowClientOffice.propTypes = {
  container: PropTypes.object,
};

export default compose(withRouter(RowClientOffice));
